/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';

export type TCreateActionCheckModel = IModel<ICreateActionCheckRequest, TCreateActionCheckResponse>;

export interface ICreateActionCheckRequest {}

export type TCreateActionCheckResponse = ICreateActionCheckResponse200 | ICreateActionCheckResponse400;

export interface ICreateActionCheckResponse200 extends IModelResponse<ICreateActionCheckResponse> {
  statusCode: 200;
}

export interface ICreateActionCheckResponse400 extends IModelResponse<ICreateActionCheckResponseError> {
  statusCode: 400;
}

export interface ICreateActionCheckResponse {
  /** Статус создания новой заявки **/
  status?: EStatus | null;
  /** Сообщение для отображения в UI **/
  message?: string | null;
}

export interface ICreateActionCheckResponseError {
  errors: any[];
  message: string;
}

export type TResponses = ICreateActionCheckResponse | ICreateActionCheckResponseError;

export enum EStatus {
  /** Заявка зарегистрирована **/
  Accepted = 'accepted',
  /** Заявка отклонена **/
  Declined = 'declined',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: ICreateActionCheckResponse): TResponse200;
  400(response: ICreateActionCheckResponseError): TResponse400;
}
